import { SelectItem } from '@ideapa/common-interfaces';

export const dbCep = 'IDEAPA_CEP01';
export const dbPartecipo = 'IDEAPA_CEP02';

export enum CustomPermissions {
  ViewAllEnti = 'view_all_enti',
}

export enum RoleCode {
  SuperAdmin = 'superAdmin',
  Admin = 'admin',
  SuperOperator = 'superOperator',
  Operator = 'operator',
  ReadonlyOperator = 'viewer',
  CompanyUser = 'companyUser',
}

export const SUPER_ENTE_CODE = '0000';

export const TAB_CLOSE_MESSAGE = 'Chiudere senza salvare?';

export const ENTE_ID_HEADER = 'x-ente-id';

export const ESERCIZIO_HEADER = 'x-anno';

export const EsercizioMinimo = 2018;

export const Segno = [
  {
    value: 'D',
    description: 'Dare',
  },
  {
    value: 'A',
    description: 'Avere',
  },
];

export enum SegnoEnum {
  Dare = 'D',
  Avere = 'A',
}

export const TipoConto = [
  {
    value: 'A',
    description: 'Attività',
  },
  {
    value: 'C',
    description: 'Costi',
  },
  {
    value: 'O',
    description: "Conti d'ordine",
  },
  {
    value: 'P',
    description: 'Passività',
  },
  {
    value: 'R',
    description: 'Ricavi',
  },
];

export enum TipoContoEnum {
  Attività = 'A',
  Costi = 'C',
  ContiOrdine = 'O',
  Passività = 'P',
  Ricavi = 'R',
}

export const Macro = [
  {
    value: 'E',
    description: 'Entrate',
  },
  {
    value: 'U',
    description: 'Uscite',
  },
];

export const Soggetto = [
  {
    value: 'A',
    description: 'A',
  },
  {
    value: 'B',
    description: 'B',
  },
];

export enum TipoSocioEnum {
  PUBBLICO = 0,
  PRIVATO = 1,
}

export const TipoSocio: SelectItem[] = [
  {
    value: TipoSocioEnum.PUBBLICO,
    description: 'PUBBLICO',
  },
  {
    value: TipoSocioEnum.PRIVATO,
    description: 'PRIVATO',
  },
];

export const TipoAsseverazioneEnte = [
  {
    value: 'D',
    description: 'Debito',
  },
  {
    value: 'C',
    description: 'Credito',
  },
];

export const TipoAsseverazioneSocieta = [
  {
    value: 'S',
    description: 'Debito',
  },
  {
    value: 'E',
    description: 'Credito',
  },
];

export const FormaGiuridica = [
  {
    value: 1,
    description: 'Società per azioni',
  },
  {
    value: 2,
    description: 'Società in accomandita per azioni',
  },
  {
    value: 3,
    description: 'Società a responsabilità limitata',
  },
  {
    value: 4,
    description: 'Società consortile per azioni',
  },
  {
    value: 5,
    description: 'Società consortile a responsabilità limitata',
  },
  {
    value: 6,
    description: 'Società cooperativa',
  },
  {
    value: 7,
    description: 'Società in accomandita semplice',
  },
  {
    value: 8,
    description: 'Società in nome collettivo',
  },
  {
    value: 9,
    description: 'Società semplice',
  },
  {
    value: 10,
    description: 'Società estera',
  },
  {
    value: 11,
    description: 'Associazione',
  },
  {
    value: 12,
    description: 'Azienda speciale',
  },
  {
    value: 13,
    description: 'Consorzio',
  },
  {
    value: 14,
    description: 'Ente pubblico',
  },
  {
    value: 15,
    description: 'Fondazione',
  },
  {
    value: 16,
    description: 'Istituzione',
  },
  {
    value: 17,
    description: 'Altra forma giuridica NON SOCIETARIA',
  },
];

export enum TipoEvento {
  NotificaInApp = 'Notifica in app',
  Email = 'Email',
}

export enum StatoEvento {
  Inviato = 'Inviato',
  Letto = 'Letto',
}

export enum TipoBilancio {
  BilancioCep = 'Bilancio Cep', // 01, 02, 03
  BilancioDiEsercizio = 'Bilancio di esercizio', // 07, 08, 09
  BilancioRiclassificato = 'Bilancio Riclassificato', // 04, 05, 06
}

export const tipiBilancio = {
  'Bilancio Cep': ['01', '02', '03'], // 01, 02, 03
  'Bilancio di esercizio': ['07', '08', '09'], // 07, 08, 09
  'Bilancio Riclassificato': ['04', '05', '06'], // 04, 05, 06
};

export const ProspettiBilancioCep = ['01', '02', '03'];

export const ProspettiBilancioDiEsercizio = ['07', '08', '09'];

export const ProspettiBilancioRiclassificato = ['04', '05', '06'];

export enum TipoAnalisiBilancio {
  StatoPatrimonialeRiclassificato = 'SPR',
  ContoEconomicoRiclassificato = 'CER',
  IndiciDiBilancioRiclassificato = 'IDBR',
}

export interface ImportiBilancioRighe {
  idProspetto: number;
  idStruttura: number;
  codiceProspetto: string;
  codice: string;
  descrizione: string;
  valore: string;
  ordinamento: number;
  importo: number | null;
  importoAM1: number | null;
  importoAM2: number | null;
  esercizio: number;
  calcolata: boolean;
}

export interface ImportiAnalisiBilancio {
  tipo: string;
  codice: string;
  titolo: string | null;
  descrizione: string;
  stileTitolo: boolean;
  stileSottotitolo: boolean;
  valore: string;
  negativo: boolean;
  ordinamento: number;
  livello: number;
  importo: number | null;
  importoAM1: number | null;
  importoAM2: number | null;
  calcolata: boolean;
}

// gap e perimetro
export enum TipologiaSoggettoGapEnum {
  PARTECIPATO = 'PARTECIPATO',
  CONTROLLATO = 'CONTROLLATO',
}

export const TipologiaSoggettoGap: SelectItem[] = [
  { value: true, description: TipologiaSoggettoGapEnum.CONTROLLATO },
  { value: false, description: TipologiaSoggettoGapEnum.PARTECIPATO },
];

export const MotivoInclusioneGap = [
  {
    value: '',
    description: 'NON SELEZIONATO',
  },
  {
    value: 'SOGGETTO SOTTOPOSTO A CONTROLLO E COORDINAMENTO',
    description: 'SOGGETTO SOTTOPOSTO A CONTROLLO E COORDINAMENTO',
  },
  {
    value: 'SOGGETTO AFFIDATARIO DIRETTO DI SERVIZI PUBBLICI',
    description: 'SOGGETTO AFFIDATARIO DIRETTO DI SERVIZI PUBBLICI',
  },
  {
    value: 'PARTECIPAZIONE RILEVANTE',
    description: 'PARTECIPAZIONE RILEVANTE',
  },
];

export const MotivoEsclusioneGap = [
  {
    value: '',
    description: 'NON SELEZIONATO',
  },
  {
    value:
      'PARTECIPAZIONE NON RILEVANTE O ASSENZA DI AFFIDI DIRETTI DI SERVIZI PUBBLICI',
    description:
      'PARTECIPAZIONE NON RILEVANTE O ASSENZA DI AFFIDI DIRETTI DI SERVIZI PUBBLICI',
  },
  {
    value: 'SOGGETTO COINVOLTO IN PROCEDURE CONCORSUALI ATTIVE',
    description: 'SOGGETTO COINVOLTO IN PROCEDURE CONCORSUALI ATTIVE',
  },
];

export const MotivoInclusionePerimetro = [
  {
    value: '',
    description: 'NON SELEZIONATO',
  },
  {
    value: 'AFFIDATARIA DIRETTA',
    description: 'AFFIDATARIA DIRETTA',
  },
  {
    value: 'PARAMETRI SUPERIORI AL MINIMO',
    description: 'PARAMETRI SUPERIORI AL MINIMO',
  },
  {
    value: 'INCLUSO PER RISPETTO SOGLIA IRRILEVANZA GLOBALE',
    description: 'INCLUSO PER RISPETTO SOGLIA IRRILEVANZA GLOBALE',
  },
];

export const MotivoEsclusionePerimetro = [
  {
    value: '',
    description: 'NON SELEZIONATO',
  },
  {
    value: 'IRRILEVANTI PER PARAMETRI INFERIORI AL MINIMO',
    description: 'IRRILEVANTI PER PARAMETRI INFERIORI AL MINIMO',
  },
  {
    value: 'IRRILEVANTE PER % PARTECIPAZIONE',
    description: 'IRRILEVANTE PER % PARTECIPAZIONE',
  },
  {
    value: "IMPOSSIBILITA' NEL REPERIRE I DATI",
    description: "IMPOSSIBILITA' NEL REPERIRE I DATI",
  },
];

export const TipologiaConsolidamento = [
  {
    value: 'INTEGRALE',
    description: 'INTEGRALE',
  },
  {
    value: 'PROPORZIONALE',
    description: 'PROPORZIONALE',
  },
];

// enum
export enum MotivoInclusioneGapEnum {
  SSCC = 'SOGGETTO SOTTOPOSTO A CONTROLLO E COORDINAMENTO',
  SADSP = 'SOGGETTO AFFIDATARIO DIRETTO DI SERVIZI PUBBLICI',
  PR = 'PARTECIPAZIONE RILEVANTE',
}

export enum MotivoEsclusioneGapEnum {
  PNR = 'PARTECIPAZIONE NON RILEVANTE O ASSENZA DI AFFIDI DIRETTI DI SERVIZI PUBBLICI',
  SCPCA = 'SOGGETTO COINVOLTO IN PROCEDURE CONCORSUALI ATTIVE',
}

export enum MotivoInclusionePerimetroEnum {
  AD = 'AFFIDATARIA DIRETTA',
  PRS = 'PARAMETRI SUPERIORI AL MINIMO',
  IRSIG = 'INCLUSO PER RISPETTO SOGLIA IRRILEVANZA GLOBALE',
}

export enum MotivoEsclusionePerimetroEnum {
  IPIM = 'IRRILEVANTI PER PARAMETRI INFERIORI AL MINIMO',
  IPP = 'IRRILEVANTE PER % PARTECIPAZIONE',
  IRD = "IMPOSSIBILITA' NEL REPERIRE I DATI",
}

export enum TipologiaConsolidamentoEnum {
  Integrale = 'INTEGRALE',
  Proporzionale = 'PROPORZIONALE',
}

export const ParereRegolarita = [
  {
    value: 'Favorevole',
    description: 'Favorevole',
  },
  {
    value: 'Non favorevole',
    description: 'Non favorevole',
  },
  {
    value: 'Non necessario',
    description: 'Non necessario',
  },
];

export interface DatiDelibera {
  nomeEnte: string;
  nomeFile: string;
  provincia: string;
  numeroDelibera: string;
  dataDelibera: string;
  idTemplate: number | null;
  // assessore: string;
  // parereRegolaritaTecnica: string;
  // motivoParereTecnicoNegativo: string | null;
  // parereRegolaritaContabile: string;
  // motivoParereContabileNegativo: string | null;
}

export interface SoggettoPerConsolidato {
  idSoggetto: number;
  tipo: TipoSoggettoEnum;
  nome: string;
  idPartecipata: number | null;
}

export enum TipoSoggettoEnum {
  Ente = 'Ente',
  Partecipata = 'Partecipata',
}

// modello nota integrativa

export enum TipologiaTemplateEnum {
  Nota_integrativa_CEP = 'Nota_integrativa_CEP',
  Nota_integrativa_Partecipo = 'Nota_integrativa_Partecipo',
  Delibera_GAP = 'Delibera_GAP',
}

export const TipologiaTemplate = [
  {
    value: TipologiaTemplateEnum.Nota_integrativa_CEP,
    description: 'Nota integrativa CEP',
  },
  {
    value: TipologiaTemplateEnum.Nota_integrativa_Partecipo,
    description: 'Nota integrativa Consolid@to',
  },
  {
    value: TipologiaTemplateEnum.Delibera_GAP,
    description: 'Delibera GAP',
  },
];

// Co.Fi.
export const StatoRecord = [
  {
    value: 0,
    description: 'Manca Piano Finanziario',
  },
  {
    value: 1,
    description: 'Record importato correttamente',
  },
  {
    value: 2,
    description: 'Record registrato',
  },
];

export enum StatoRecordEnum {
  MancaPianoFinanziario = 0,
  RecordImportatoCorrettamente = 1,
  RecordRegistrato = 2,
}

export const Es = [
  {
    value: 'E',
    description: 'E',
  },
  {
    value: 'S',
    description: 'S',
  },
];

export const Cr = [
  {
    value: 'C',
    description: 'C',
  },
  {
    value: 'R',
    description: 'R',
  },
];

// Riepilogo Prospetti
export interface RiepilogoProspetti {
  idProspetto: number;
  idStrutturaProspetto: number;
  idPianoConti: number;
  importoIniziale: number | null;
  movimentiDare: number | null;
  movimentiAvere: number | null;
  importoFinale: number | null;
}

export interface RigaSaldo {
  idPianoConti: number;
  importo: number | null;
  importoIniziale: number | null;
}

export interface RigaRegistrazione {
  idPianoConti: number;
  dare: number | null;
  avere: number | null;
}
export interface RigaBilancio {
  codice: string;
  lettera: string;
  rif1: string;
  rif2: string;
  rif3: string;
  rif4: string;
  descrizione: string;
  ordinamento: number;
  titolo: boolean;
  sottoTitolo: boolean;
  calcolata: boolean;
  soloBdap: boolean;
  importo: number | null;
  importoAnnoPrecedente: number | null;
  nota1: string;
  nota2: string;
  xbrl: string;
  xbrlPerMissioni: string;
  idProspetto: number;
  codiceProspetto: string;
  idStrutturaProspetto: number | null;
}

export interface ImportoCostiPerMissione {
  contenutoCella: string;
  codiceMissione: string;
  idStrutturaProspetto: number;
  importo: number;
  totale: boolean;
}

export const TipoBdapCep: SelectItem[] = [
  {
    value: 'ChiusuraEsercizioPrecedente',
    description: 'Chiusura esercizio precedente',
  },
  {
    value: 'StatoPatrimonialeIniziale',
    description: 'Stato patrimoniale iniziale',
  },
];

export enum TipoBdapCepEnum {
  ChiusuraEsercizioPrecedente = 'Chiusura esercizio precedente',
  StatoPatrimonialeIniziale = 'Stato patrimoniale iniziale',
}

export interface ParametriEstratti {
  codiceBdap: string;
  tassonomia: string;
  intervalAnnoCorrente: string | null;
  instantAnnoCorrente: string | null;
  intervalAnnoPrecedente: string | null;
  instantAnnoPrecedente: string | null;
  umMonetary: string | null;
  umPure: string | null;
  uploadedFile: string;
  uploadedFileName: string;
  rowPrefix: string;
  contextPrefix: string;
  schemaPrefix: string;
}
export interface ParametriInviati {
  tassonomia: string;
  tipoFileDownload: TipoBdapCepEnum;
  intervalAnnoCorrente: string | null;
  instantAnnoCorrente: string | null;
  intervalAnnoPrecedente: string | null;
  instantAnnoPrecedente: string | null;
  umMonetary: string | null;
  umPure: string | null;
}

export enum TableCellTypeEnum {
  Cell = 'Cell',
  Header = 'Header',
  Total = 'Total',
}

export enum DownloadType {
  Word = 'docx',
  Pdf = 'pdf',
  Exel = 'xlsx',
}

export interface LogTime {
  description: string;
  time: number;
  diff: number;
}

export interface RiepilogoPerTipologia {
  id: number;
  codice: string;
  descrizione: string;
  totals: number;
  dare: number;
  avere: number;
  rateizzati: number;
  daRegistrare: number;
}

export enum LoginStatusEnum {
  failed,
  completed,
  needChooseMfaMethod,
  needMASetup,
  needMAVerification,
  needEmailOtpCodeVerification,
}

export enum MFAMethodEnum {
  None = 0,
  MicrosoftAuthenticator = 1,
  EmailOtpCode = 2,
}

export enum TipoOperazioneEnum {
  Elisione = 'Elisione',
  PreConsolidamento = 'Pre-Consolidamento',
}

export interface RigaCheck {
  tipo: string;
  idBilancio: number;
  idRiga: number;
  idDettaglio: number | null;
  idPartecipataEnte: number | null;
  codice: string;
  valore: string | null;
  importo: number;
  importoAP: number | null;
  importoNoEli: number | null;
  importoNoPre: number | null;
  importoNoEliNoPre: number | null;
}
